(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("3d-transformations", [], factory);
	else if(typeof exports === 'object')
		exports["3d-transformations"] = factory();
	else
		root["3d-transformations"] = factory();
})(self, function() {
return 